// The demo league (scenario O6, docs/design/PLAN-2026-10-09-demo-league.md).
//
// A real league in the database, held still at the Tuesday morning after a
// week's games (`leagues.frozen_at`, 0051), that anyone can look around with
// no account. Its reads are the API's ordinary league reads under
// `/api/leagues/demo/…`, answered as the seat a visitor sits in; every write
// to it is refused.

import { z } from 'zod';
import { LeagueCard } from './views';

/**
 * The demo league's id. Well known, so a client opens `/l/demo` and reads
 * `/api/leagues/demo/…` without asking first; `GET /api/demo` says whether
 * one has been built here, and the moment it stands at.
 */
export const DEMO_LEAGUE_ID = 'demo';

/** `GET /api/demo` — the league a visitor looks around. */
export const DemoView = z.object({
  /** As the hub would show it to the seat a visitor sits in. */
  card: LeagueCard,
  /**
   * The moment the league is held at. Every read of it is answered as of
   * this instant, so a client telling time on its screens tells it by this
   * too: "Thursday 7:15 PM" is two days off, not a date long gone.
   */
  frozenAt: z.string(),
  /**
   * The week just played: the latest whose every matchup is final, or null
   * before one has been. What a visitor came to look back on, so a client
   * opens its matchup there; the league's current week is already the next.
   */
  week: z.number().int().positive().nullable(),
});
export type DemoView = z.infer<typeof DemoView>;
